var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46905 4.00209L7.89834 0.572811C8.03069 0.444984 8.03436 0.234074 7.90654 0.101719C7.77871 -0.030637 7.5678 -0.034307 7.43544 0.0935196C7.43267 0.096194 7.42994 0.098927 7.42725 0.101719L3.99794 3.531L0.568648 0.101699C0.436292 -0.0261275 0.225381 -0.0224575 0.097554 0.109898C-0.0271496 0.239013 -0.0271496 0.443696 0.097554 0.572811L3.52684 4.00209L0.097554 7.43137C-0.032518 7.56146 -0.032518 7.77237 0.097554 7.90246C0.227645 8.03251 0.438556 8.03251 0.568648 7.90246L3.99794 4.47318L7.42723 7.90246C7.55958 8.03029 7.77049 8.02662 7.89832 7.89426C8.023 7.76515 8.023 7.56046 7.89832 7.43137L4.46905 4.00209Z",
    fill: "#5C5B5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.78da80982bfd402d5a867364c6a4fad4.svg";
export { ForwardRef as ReactComponent };